import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SfFormDateComponent } from './components/forms/custom-fields/sf-form-date/sf-form-date.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { MomentModule } from 'ngx-moment';
import { UserFormComponent } from './components/forms/custom-forms/user-form/user-form.component';
import { SilReferralFormComponent } from './components/forms/custom-forms/sil-referral-form/sil-referral-form.component';
import { SfFormDatetimeComponent } from './components/forms/custom-fields/sf-form-datetime/sf-form-datetime.component';
import { SfFormTimeComponent } from './components/forms/custom-fields/sf-form-time/sf-form-time.component';
import { CalendarDayPipe } from './pipes/calendar-day.pipe';
import { Ngxh6Module, NotificationBadgeComponent, MessageAndNotificationModule, SfFormModule } from '@hutsix/ngxh6';
import { NavbarComponent } from './components/ui/navbar/navbar.component';
import { LoginComponent } from './routes/user/login/login.component';
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { ReloadPageComponent } from './routes/reload-page/reload-page.component';
import { AppSidebarComponent } from './components/app-sidebar/app-sidebar.component';
import { QuarterSelectorComponent } from './components/ui/quarter-selector/quarter-selector.component';
import { DataExportButtonComponent } from './components/ui/data-export-button/data-export-button.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    url: '#',
    maxFilesize: 50,
    // acceptedFiles: '',
    maxFiles: 1,
    addRemoveLinks: true,
    autoQueue: false,
    autoProcessQueue: false,
    uploadMultiple: false,
    headers: {
        'Cache-Control': '',
        'X-Requested-With': '',
    },
    method: 'post',
};

@NgModule({
    // eslint-disable-next-line prettier/prettier
    declarations: [
        SfFormDateComponent,
        SfFormDatetimeComponent,
        SfFormTimeComponent,
        UserFormComponent,
        SilReferralFormComponent,
        NavbarComponent,
        LoginComponent,
        DashboardComponent,
        ReloadPageComponent,
        AppSidebarComponent,
        QuarterSelectorComponent,
        DataExportButtonComponent,
        CalendarDayPipe,
    ],

    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MessageAndNotificationModule,
        NgbTooltipModule,

        // To be exported
        Ngxh6Module,
        SfFormModule.forRoot({
            customTypes: [
                { prefix: 'date', component: SfFormDateComponent },
                { prefix: 'datetime', component: SfFormDatetimeComponent },
                { prefix: 'time', component: SfFormTimeComponent },
            ],
        }),
        DropzoneModule,
        MomentModule.forRoot({
            relativeTimeThresholdOptions: {
                s: 60,
                m: 60,
                h: 24,
                d: 7,
                w: 4,
                M: 12,
            },
        }),
        NotificationBadgeComponent,
    ],
    exports: [
        // Declared
        CalendarDayPipe,
        SfFormDateComponent,
        SfFormDatetimeComponent,
        SfFormTimeComponent,
        NavbarComponent,
        AppSidebarComponent,
        QuarterSelectorComponent,
        DataExportButtonComponent,

        // IMPORTS:
        Ngxh6Module,
        SfFormModule,
    ],
    providers: [
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG,
        },
    ],
})
export class SharedModule {}
